import routes from 'actions/routes';

import { generateCreateActionCreator, generateReadActionCreator, generateUpdateActionCreator } from 'actions/crudActionCreators';
import ACTION_NAMES from 'actions/ACTION_NAMES';

const createBroadcast = generateCreateActionCreator(routes.API_BROADCAST, ACTION_NAMES.BROADCAST);
const inactivateBroadcast = generateUpdateActionCreator(routes.API_BROADCAST, ACTION_NAMES.BROADCAST);
const getBroadcastMessages = generateReadActionCreator(routes.API_BROADCAST, ACTION_NAMES.BROADCAST);
const checkNewBroadcastMessages = generateReadActionCreator(`${routes.API_BROADCAST}/check`, ACTION_NAMES.NEW_BROADCAST_MESSAGE);
const ignoreBroadcastMessage = generateUpdateActionCreator(`${routes.API_BROADCAST}/ignore`, ACTION_NAMES.IGNORE_BROADCAST);
const getCreatedByUsers = generateReadActionCreator(`${routes.API_BROADCAST}/created-by-users`, ACTION_NAMES.BROADCAST_CREATED_BY_USERS);

export default {
  createBroadcast,
  inactivateBroadcast,
  getBroadcastMessages,
  ignoreBroadcastMessage,
  checkNewBroadcastMessages,
  getCreatedByUsers
};
